var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lib-stepper"},[_c('div',{staticClass:"step"},[_c('i',{staticClass:"iconfont icon-jianshao",on:{"mousedown":_vm.sub}}),_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.input($event.target.value)}}}),_c('i',{staticClass:"iconfont icon-jiahao",on:{"mousedown":_vm.add}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }